<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <v-btn icon="mdi-chevron-left" @click="$router.replace('/sells')" variant="elevated" :density="$vuetify.display.mdAndUp ? 'compact' : 'comfortable' " color="primary"></v-btn>
          <h2 class="mx-3" v-if="$vuetify.display.mdAndUp">Nuova vendita</h2>
          <h3 class="mx-3" v-else>Nuova vendita</h3>
        </div>
        <div class="d-flex align-center justify-end" >

        </div>
      </v-col>
      <v-col cols="12">
        <v-progress-linear color="primary" class="w-100" indeterminate v-if="loading" height="2"></v-progress-linear>
        <v-divider class="mb-3" v-else></v-divider>
      </v-col>


      <v-col cols="12">
        <v-form ref="form" @submit.prevent="nexStep()">
          <v-stepper v-model="step" :items="['Seleziona l\'acquirente','Seleziona i prodotti','Dettagli di spedizione','Riepilogo']" hide-actions>
            <template #item.1>
              <v-row class="ma-1">
                <v-col cols="12"><h3>Seleziona l'acquirente</h3></v-col>
                <v-col cols="12" lg="6" xl="4">
                  <v-autocomplete
                      label="Utente*" :items="userOptions" v-model="editingItem.user_id" @update:model-value="onUserSelected"
                      :hint="fiscalCode" persistent-hint :rules="[rules.required]" autocomplete="off">
                    <template #item="{item, props}">
                      <v-list-item v-bind="props" :subtitle="item.fiscal_code"></v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" class="d-flex justify-space-between">
                  <div></div>
                  <v-btn :disabled="!editingItem.user_id" color="primary" type="submit">Continua</v-btn>
                </v-col>
              </v-row>
            </template>
            <template #item.2>
              <v-row class="ma-1" >
                <v-col cols="12"><h3>Prodotti nell'ordine di acquisto</h3></v-col>
                <v-col cols="12" lg="6">
                  <v-table class="rounded border" density="compact" striped="even">
                    <thead>
                    <tr>
                      <th>Pacchetto</th>
                      <th>Prodotto</th>
                      <th>Prezzo</th>
                      <th style="width: 60px"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="!editingItem.items || !editingItem.items.length">
                      <td colspan="4" class="text-center font-italic">
                        Al momento non ci sono prodotti nell'ordine.
                      </td>
                    </tr>
                    <tr v-else v-for="(el, i) in editingItem.items" :key="`${el}_${i}`">
                      <td>
                        {{getKitName(el)}}
                      </td>
                      <td>
                        {{getProductName(el)}}
                      </td>
                      <td>
                        {{getProductPrice(el)}}
                      </td>
                      <td>
                        <v-btn variant="text" icon="mdi-close" color="primary" @click="removeItem(i)"></v-btn>
                      </td>
                    </tr>
                    </tbody>
                  </v-table>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-row>
                    <v-col cols="12" lg="6">
                      <v-autocomplete label="Seleziona pacchetto" v-model="kitId" :items="kitOptions" @update:model-value="productId = undefined" autocomplete="off"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" lg="6">
                      <v-autocomplete label="Seleziona prodotto" v-model="productId" :items="productOptions" :disabled="!kitId" append-icon="mdi-plus" @click:append="addItem()" autocomplete="off"></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <h3>Aggiungi dei giorni di pausa abbonamento</h3>
                  <p class="mb-0">L'utente può ancora acquistare <strong>{{subPauseExtraAvailable}}</strong> giorni di pausa su <strong>{{settings.max_days_of_subscription_pause}}</strong> per quest'anno</p>
                </v-col>
                <v-col cols="12" md="6" lg="4" xl="3">
                  <v-text-field
                      label="Numero di giorni di pausa extra"
                      v-model="editingItem.sub_pause_days"
                      type="number"
                      step="1"
                      min="0"
                      max="20"
                      :rules="[maxSubRule]" autocomplete="off"
                  ></v-text-field>
                  <p :key="'costo'"><strong>Costo aggiuntivo</strong>: {{(settings.extra_day_of_sub_pause_price * editingItem.sub_pause_days).toFixed(2)}} €</p>
                </v-col>
                <v-col cols="12">
                  <h3>Opzioni extra di acquisto</h3>
                </v-col>
                <v-col cols="12" md="6" lg="4" xl="3">
                  <v-switch label="Home Kit (in regalo o nell'ordine)" v-model="editingItem.home_kit" color="primary"></v-switch>
                </v-col>

                <v-col cols="12" md="6" lg="4" xl="3">
                  <v-switch label="Richiesta tessera MSP (nuova o rinnovo)" :hint="`La tessera ha un costo di ${settings.coni_card_price}€`" color="primary" persistent-hint v-model="editingItem.card"></v-switch>
                </v-col>
                <v-col cols="12" md="6" lg="4" xl="3">
                  <v-switch label="Richiesta spedizione" persistent-hint disabled v-model="editingItem.expedition" color="primary"
                            hint="Questo flag si aggiorna automaticamente in base al contenuto dell'ordine" ></v-switch>
                </v-col>
                <v-col cols="12" class="d-flex justify-space-between">
                  <v-btn variant="text" @click="step = 1">Indietro</v-btn>
                  <v-btn :disabled="!editingItem.items.length && !editingItem.card && !editingItem.sub_pause_days" color="primary" type="submit" >Continua</v-btn>
                </v-col>
              </v-row>
            </template>
            <template #item.3>
              <v-row class="ma-1">
                <v-col cols="12"><h3>Dettagli di spedizione</h3></v-col>
                <v-col cols="12" md="7" lg="6" xl="4">
                  <v-text-field label="Indirizzo" v-model="editingItem.address!.name" hint="Via\Piazza ..." :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="12" md="5" lg="4" xl="3">
                  <v-text-field label="Città" v-model="editingItem.address!.city" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2">
                  <v-text-field label="Provincia" v-model="editingItem.address!.province" hint="es. PG" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2">
                  <v-text-field label="CAP" v-model="editingItem.address!.zip_code" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="12" class="d-flex justify-space-between">
                  <v-btn variant="text" @click="step = 2">Indietro</v-btn>
                  <v-btn :disabled="!editingItem.address?.zip_code || !editingItem.address?.province || !editingItem.address?.city || !editingItem.address?.name" color="primary" type="submit">Continua</v-btn>
                </v-col>
              </v-row>
            </template>
            <template #item.4>
              <v-row class="ma-1">
                <v-col cols="12">
                  <h2>Riepilogo</h2>
                </v-col>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12">
                  <h3 class="mb-3">Elementi nell'ordine</h3>
                  <p class="mb-0" v-for="(id, i) in editingItem.items"><strong>{{getKitName(id)}} - {{getProductName(id)}}</strong>: {{getProductPrice(id)}}</p>
                  <p class="mb-0"  v-if="editingItem.sub_pause_days"><strong>{{editingItem.sub_pause_days}} giorni extra di pausa</strong>: {{(editingItem.sub_pause_days * settings.extra_day_of_sub_pause_price).toFixed(2)}} €</p>
                  <p class="mb-0"  v-if="editingItem.card"><strong>Tessera MSP</strong>: {{settings.coni_card_price}} €</p>
                </v-col>
                <v-col cols="12" v-if="editingItem.expedition">
                  <h3 class="mb-3">Indirizzo di spedizione</h3>
                  <p class="mb-0">{{editingItem.address?.name}}, {{editingItem.address?.city}}, {{editingItem.address?.province}}, {{editingItem.address?.zip_code}}</p>
                </v-col>
                <v-col cols="12">
                  <h3>Informazioni sul pagamento</h3>
                </v-col>
                <v-col cols="12" lg="6" xl="4">
                  <v-text-field label="ID di pagamento / n° ricevuta" v-model="editingItem.payment_uid"
                                hint="lascia vuoto se vuoi che sia generato automaticamente" persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="d-flex justify-space-between">
                  <v-btn variant="text" @click="step = editingItem.expedition ? 3 : 2">Indietro</v-btn>
                  <v-btn color="primary" type="submit">Inserisci l'acquisto</v-btn>
                </v-col>
              </v-row>
            </template>

          </v-stepper>
        </v-form>
      </v-col>


      <v-col cols="12">
        <p class="mt-3"><small >* campi obbligatori</small></p>
        <v-divider v-if="!loading"></v-divider>
        <v-progress-linear color="primary" class="w-100" indeterminate v-else height="2"></v-progress-linear>
      </v-col>
      <v-col cols="12" class="d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <v-btn prepend-icon="mdi-chevron-left" @click="$router.replace('/sells')" variant="elevated" color="primary" density="compact">Indietro</v-btn>
        </div>
        <div class="d-flex align-center">
        </div>
      </v-col>
    </v-row>


    <v-dialog v-model="cardDialog" max-width="500">
      <v-card>
        <v-card-title>Tessera MSP scaduta</v-card-title>
        <v-card-text>
          <p>La tessera MSP di questo utente è scaduta, vuoi aggiungere il rinnovo della tessera al carrello?<br>La tessera ha un costo di {{settings.coni_card_price}}€</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn @click="cardDialog = false;">No</v-btn>
          <v-btn variant="elevated" color="primary" @click="addConiCardToCart()">Sì</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script lang="ts">
import utils from '../utils';
import config from "../config";
import {DateTime} from "luxon";
import {computed, inject, onMounted, ref, useTemplateRef} from "vue";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRoute, useRouter} from "vue-router";
import type {Cart, Purchase} from "@/models.ts";
import api from "@/api";
import type {VForm} from "vuetify/components";
import rules from "@/utils/rules.ts";
import {cartStatusOptions, paymentMethods} from "@/consts.ts";
export default {
  name: "PurchaseWizard",
  setup(props, ctx) {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const route = useRoute()
    const router = useRouter()
    const kitId = ref<string|undefined>()
    const productId = ref<string|undefined>()
    const loading = ref(false)
    const cardDialog = ref(false)
    const form = useTemplateRef<VForm>('form')
    const userPurchases = ref<Purchase[]>([])

    const editingItem = ref<Cart>({
      block_edit: false,
      card: false,
      evaded: false,
      expedition: false,
      home_kit: false,
      items: [],
      payment_method: "manual",
      payment_uid: "",
      paypal_detail: "",
      paypal_request_id: "",
      paypal_status: "",
      status: "paid",
      sub_pause_days: 0,
      user_id: "",
      address : { name : '',  city : '', province : '', zip_code : ''}
    })

    const step = ref<number>(1)

    const subPauseExtraAvailable = computed(()=>{
      const user = globals.users.value.find(i => i._id === editingItem.value.user_id)
      if(!user) return 0
      const now = DateTime.now()
      const pauses = globals.pauses.value.filter(p => {
        if(p.user_id !== user._id) return false;
        const from = DateTime.fromISO(p.from)
        const to = DateTime.fromISO(p.to)
        return now > from && now < to
      })
      let num = 0;
      for(let i = 0; i < pauses.length; i++) {
        const p = pauses[i]
        num+=p.num_days;
      }

      return Math.max(0, globals.settings.value.extra_day_of_sub_pause_price - num);
    })

    const refreshPurchases = async ()=>{
      const res = await api.list<Purchase>('purchases', { user: editingItem.value.user_id}, 0, 0)
      userPurchases.value = res.data ?? [];
    }

    onMounted(async ()=>{
      await globals.waitForInit
      await router.isReady()
      await Promise.all([
        globals.refreshEmpty('users'),
        globals.refreshEmpty('kits'),
        globals.refreshEmpty('products'),
        globals.refreshEmpty('pauses'),
        globals.refreshEmpty('cards'),
      ])

    })


    return {
      cardDialog,
      loading,
      form,
      rules,
      step,
      kitId,
      productId,
      settings : globals.settings,
      editingItem,
      subPauseExtraAvailable,
      maxSubRule: (value:string|undefined) => {
        if (value) {
          const val = utils.toInt(value, subPauseExtraAvailable.value + 1);
          if (val > subPauseExtraAvailable.value) return `deve essere un numero intero minore o uguale a ${subPauseExtraAvailable.value}`;
        }
        return true;
      },
      kitOptions : computed(()=>{
        let items= globals.kits.value.filter(i => i.pub)

        items.sort((a, b) => {
          if(a.category.is_gym_category && !b.category.is_gym_category) return -1
          if(!a.category.is_gym_category && b.category.is_gym_category) return 1
          if(a.order < b.order) return -1
          if(a.order > b.order) return 1
          return 0
        })
        return items.map(i => {
          return { title : i.title.it + ` (${i.order})`, value : i._id}
        })
      }),
      productOptions : computed(()=>{
        if(!kitId.value) return []
        return globals.products.value.filter(i => {
          if(i.kit_id !== kitId.value) return false;
          if(editingItem.value.items.includes(i._id!)) return false;
          if(!i.is_seats_product) {
            if(userPurchases.value.map(p => p.product_id).includes(i._id!)) return false
          }
          return true
        }).map(i => {
          return { title : `${i.title.it}(${i.sku})`, value : i._id}
        })
      }),
      formatDate : utils.formatDate,
      userOptions : computed(()=>{
        return globals.users.value.map(i => {
          return { title : i.name + ' ' + i.surname, value : i._id, fiscal_code : i.fiscal_code }
        })
      }),
      fiscalCode : computed(()=>{
        if(!editingItem.value.user_id) return undefined
        const user = globals.users.value.find(i => editingItem.value.user_id === i._id)
        if(!user) return undefined
        return user.fiscal_code
      }),
      getKitName(productId:string) {
        const product = globals.products.value.find(i => i._id === productId)
        if(!product) return '-'
        const kit = globals.kits.value.find(i => i._id === product.kit_id)
        return kit?.title?.it ?? '-'
      },
      getProductName(productId:string) {
        const product = globals.products.value.find(i => i._id === productId)
        return product?.title?.it ?? '-'
      },
      getProductPrice(productId:string) {
        const product = globals.products.value.find(i => i._id === productId)
        return product ? `€${product.price.toFixed(2)}` : '-'
      },
      addItem() {
        if(!productId.value) return
        const p = globals.products.value.find(i => i._id === productId.value)
        if(!p) return;
        if(p.expedition) {
          editingItem.value.expedition = p.expedition
        }
        editingItem.value.items.push(productId.value)
        productId.value = undefined
      },
      removeItem(i:number) {
        messages.requestConfirm("Richiesta conferma", "Sei sicuro di vole eliminare questo prodotto dall'ordine?", false, ok => {
          if(ok) editingItem.value.items.splice(i,1)
          editingItem.value.expedition = false
          for(let i = 0; i < editingItem.value.items.length; i++) {
            const p = globals.products.value.find(p => p._id === editingItem.value.items[i]);
            if(p && p.expedition) {
              editingItem.value.expedition = true
            }
          }
          if(editingItem.value.status === 'expedition' || editingItem.value.status === 'paid') {
            editingItem.value.status = 'closed'
          }
        })
      },
      async onUserSelected() {
        editingItem.value.card = false
        if(!editingItem.value.user_id) return
        await refreshPurchases();
        const cards = globals.cards.value.filter(c => {
          if(c.user_id !== editingItem.value.user_id) return false
          const dt = DateTime.fromISO(c.expiration)
          return dt.isValid && dt > DateTime.now()
        })
        if(!cards.length) {
          cardDialog.value = true
        }
      },
      addConiCardToCart() {
        editingItem.value.card = true
        cardDialog.value = false
      },
      paymentMethods,
      cartStatusOptions,
      async nexStep() {
        const v = await form.value!.validate()
        if(!v.valid) return;
        console.log(step.value, editingItem.value.expedition)
        if(step.value === 2 && !editingItem.value.expedition) {
          step.value = 4;
          return
        }
        if(step.value < 4) {
          step.value++
          return
        }

        messages.requestConfirm("Richiesta conferma", "Sei sicuro di voler inserire quest'ordine d'acquisto?", false, async ok => {
          if(!ok) return
          loading.value = true;
          editingItem.value.sub_pause_days = utils.toInt(editingItem.value.sub_pause_days, 0)

          if(editingItem.value.expedition) {
            editingItem.value.status = 'paid'
          } else {
            editingItem.value.status = 'closed'
          }

          editingItem.value.evaded = true
          editingItem.value.payment_method = 'manual'
          if(!editingItem.value.payment_uid) editingItem.value.payment_uid = utils.genPaymentUID()
          const res = await api.save<Cart>('carts', editingItem.value)
          loading.value = false;
          if(!res.success) {
            messages.error(res.message ?? Msg.serverError)
            if(res.status === 401) {
              auth.logout()
            }
            return
          }

          editingItem.value = res.data!
          messages.success("Vendita effettuata!")
          await router.replace(`/sells/${editingItem.value._id}/view`)
        })


      },
    }
  }
}
</script>

<style scoped></style>
